import { useCallback, useEffect, useState } from "react";
import {
  fetchAuditorAuditReports,
  type AuditReportListItem,
  type AuditReportsQuery,
} from "../api/auditorApi";
import { getAuthToken } from "../auth";

export function useAuditReports(query: AuditReportsQuery = {}) {
  const [reports, setReports] = useState<AuditReportListItem[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    if (!getAuthToken()) {
      setReports([]);
      setError(null);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await fetchAuditorAuditReports(query);
      setReports(response.audit_reports ?? []);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Impossible de charger les rapports.");
      setReports([]);
    } finally {
      setLoading(false);
    }
  }, [query.q, query.status]);

  useEffect(() => {
    void load();
  }, [load]);

  return { reports, loading, error, reload: load };
}
